import { useStyles } from "./styles";
import type { WebContainerProps } from "./types";

export const Container = ({
  children,
  style,
  className,
  background,
  colors,
  gradient,
  angle,
}: WebContainerProps) => {
  const { backgroundStyle, layoutStyle } = useStyles({
    background,
    colors,
    gradient,
    angle,
  });

  return (
    <div
      className={className}
      style={{
        ...(!className ? layoutStyle : {}),
        ...backgroundStyle,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
